import { render, staticRenderFns } from "./BackofficeNegativaAutorizacao.vue?vue&type=template&id=14ed0899"
import script from "./BackofficeNegativaAutorizacao.vue?vue&type=script&lang=ts"
export * from "./BackofficeNegativaAutorizacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports